<template>
  <table class="ContentSimpleTable">
    <tr v-for="row in data" :key="row.label">
      <td>{{ row.label }}</td> 
      <td>{{ row.value }}</td>
    </tr>
  </table>
</template>

<script>
export default {
  name: 'ContentSimpleTable',
  props: {
    data: {
      type: Array,
      required: true
    }
  }
}
</script>

<style lang="scss">
  .ContentSimpleTable {
    tr {
      line-height: 24px;

      td {
        color: #454545;
        font-family: $font_nav;

        &:first-child {
          display: block;
          color: #9B9B9B;
          margin-right: 12px;
        }
      }
    }
  }
</style>
